function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("rect", {
  x: 155,
  y: 88,
  width: 18,
  height: 29,
  rx: 9,
  fill: "url(#alt)"
});

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  x: 124,
  y: 96,
  width: 18,
  height: 21,
  rx: 9,
  fill: "url(#b)"
});

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  x: 93,
  y: 96,
  width: 18,
  height: 21,
  rx: 9,
  fill: "url(#c)"
});

var _ref4 = /*#__PURE__*/React.createElement("rect", {
  x: 62,
  y: 96,
  width: 18,
  height: 21,
  rx: 9,
  fill: "url(#d)"
});

var _ref5 = /*#__PURE__*/React.createElement("rect", {
  x: 31,
  y: 96,
  width: 18,
  height: 21,
  rx: 9,
  fill: "url(#e)"
});

var _ref6 = /*#__PURE__*/React.createElement("rect", {
  y: 96,
  width: 18,
  height: 21,
  rx: 9,
  fill: "url(#f)"
});

var _ref7 = /*#__PURE__*/React.createElement("rect", {
  x: 181,
  y: 70,
  width: 18,
  height: 47,
  rx: 9,
  fill: "url(#g)"
});

var _ref8 = /*#__PURE__*/React.createElement("rect", {
  x: 207,
  y: 46,
  width: 18,
  height: 71,
  rx: 9,
  fill: "url(#h)"
});

var _ref9 = /*#__PURE__*/React.createElement("rect", {
  x: 233,
  y: 22,
  width: 18,
  height: 95,
  rx: 9,
  fill: "url(#i)"
});

var _ref10 = /*#__PURE__*/React.createElement("rect", {
  x: 259,
  width: 18,
  height: 117,
  rx: 9,
  fill: "url(#j)"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M164 86s9-6 9-13a9 9 0 1 0-18 0c0 7 9 13 9 13Zm3-13a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z",
  fill: "url(#k)"
});

var _ref12 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "alt",
  x1: 164,
  y1: 94.406,
  x2: 164,
  y2: 117,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F034A6"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F034A6",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "b",
  x1: 133,
  y1: 100.639,
  x2: 133,
  y2: 117,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F034A6"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F034A6",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "c",
  x1: 102,
  y1: 100.639,
  x2: 102,
  y2: 117,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F034A6"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F034A6",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "d",
  x1: 71,
  y1: 100.639,
  x2: 71,
  y2: 117,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F034A6"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F034A6",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "e",
  x1: 40,
  y1: 100.639,
  x2: 40,
  y2: 117,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F034A6"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F034A6",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "f",
  x1: 9,
  y1: 100.639,
  x2: 9,
  y2: 117,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F034A6"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F034A6",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "g",
  x1: 190,
  y1: 80.382,
  x2: 190,
  y2: 117,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F034A6"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F034A6",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "h",
  x1: 216,
  y1: 61.684,
  x2: 216,
  y2: 117,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F034A6"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F034A6",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "i",
  x1: 242,
  y1: 42.985,
  x2: 242,
  y2: 117,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F034A6"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F034A6",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "j",
  x1: 268,
  y1: 25.845,
  x2: 268,
  y2: 117,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F034A6"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F034A6",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "k",
  x1: 164,
  y1: 68.86,
  x2: 164,
  y2: 97,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#5779FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#2C3D80",
  stopOpacity: 0
})));

function SvgPlanoGrafico({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 277,
    height: 117,
    viewBox: "0 0 277 117",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlanoGrafico);
export default __webpack_public_path__ + "static/media/plano-grafico.f2554baeb07c454097027653b0d1bea1.svg";
export { ForwardRef as ReactComponent };